<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<dropdown-menu #parent (onOpen)="onOpen()">
	<div dropdown-label>
		<div
			data-testing-locator="support-menu-toggle"
			class="nav-bar-menu-item"
			[ngClass]="{ 'nav-bar-menu-item-expanded': parent.opened$ | async }"
		>
			Support<span [hidden]="(intercomService.notificationCount$ | async) <= 0">
				({{ intercomService.notificationCount$ | async }})</span
			>
			<span [hidden]="parent.opened$ | async" class="nav-bar-menu-dropdown-icon"
				><i class="material-icons notranslate">keyboard_arrow_down</i></span
			>
			<span [hidden]="!(parent.opened$ | async)" class="nav-bar-menu-dropdown-icon"
				><i class="material-icons notranslate">keyboard_arrow_up</i></span
			>
		</div>
	</div>

	<div dropdown-content>
		<div class="support-menu nav-bar-dropdown-menu no-print">
			<span
				class="nav-bar-dropdown-menu-item"
				*ngFor="let menuItem of supportMenuItems | async"
				(click)="menuItem.onClick()"
			>
				<i class="material-icons notranslate">{{ menuItem.icon }}</i>
				{{ menuItem.text }}
			</span>

			<div
				class="nav-bar-dropdown-menu-item live-chat-menu-item"
				(click)="intercomService.toggle(); parent.toggle()"
			>
				<i class="material-icons notranslate">chat_bubble_outline</i>
				{{ appStrings.SUPPORT_MENU_LIVE_CHAT }}
				<ng-container *ngIf="intercomService.notificationCount$ | async as notificationCount">
					<span [hidden]="notificationCount <= 0">({{ notificationCount }})</span>
				</ng-container>
			</div>
		</div>
	</div>
</dropdown-menu>
